jQuery(document).ready(function ($) {
  // Vars
  $menuButton = $('.component-menu-trigger');
  $menuModal = $('.menu-modal');
  $menuModalBg = $('.menu-modal-bg');
  $menuModalContent = $('.menu-modal-content');
  $backgroundBody = $('body');

  $('.component-menu-trigger').click(function () {
    menuToggleClass($menuButton, $menuModal, $menuModalBg, $menuModalContent, $backgroundBody);
  });

  var menuToggleClass = function ($menuButton, $menuModal, $menuModalBg, $menuModalContent, $backgroundBody) {
    // Actions
    $menuButton.toggleClass('is-open');
    $menuModal.toggleClass('is-open');
    $backgroundBody.toggleClass('no-scroll');

    if ($menuButton.hasClass('is-open')) {
      menuModalOpen($menuModalBg, $menuModalContent, $menuModal);
    } else {
      menuModalClose($menuModalBg, $menuModalContent, $menuModal);
    }
  };

  var menuModalOpen = function($menuModalBg, $menuModalContent, $menuModal){
    $menuModalBg.css({
      opacity: 1,
      visibility: 'visible',
    });
    $menuModalContent.css({
      opacity: 1,
      visibility: 'visible',
    });
    $menuModal.css('z-index', 98);
  };

  var menuModalClose = function($menuModalBg, $menuModalContent, $menuModal){
    $menuModalBg.css({
      opacity: 0,
    });
    $menuModalContent.css({
      opacity: 0,
    });
    $menuModal
      .delay(400)
      .queue(function (next) {
        $menuModal.css('z-index', -1);
        $menuModalBg.css({
          visibility: 'hidden',
        });
        $menuModalContent.css({
          visibility: 'hidden',
        });
        next();
      });
  };

  //
  // Width-Detection
  //
  $nav_canva = $('.ctn-menu');
  $nav_desktop = $('.menu');
  $nav_desktop_menu_content = $('.menu-content');
  $nav_mobile_icon = $('.menu-icon');
  $nav_desktop_width_remember = '';

  var get_nav_width = function(){
    $result = {
      canva: $nav_canva.width(), 
      desktopNav: $nav_desktop.width()
    };
    return $result;
  };

  var set_nav_state = function(){
    // TODO: Kann man das in eine Schleife packen?
    $widths = get_nav_width();
    set_nav_state_action($widths);
    // bei init verzögert der css Aufbau und damit die Breite des Menüs 
    // -> check, ob sich etwas geändert hat = erster Aufrauf bei mobil
    $widths_init_check = get_nav_width();
    if($widths_init_check.desktopNav != $widths.desktopNav){
      set_nav_state_action($widths_init_check);
    }
    return $result;
  };

  var set_nav_state_action = function($widths){
    if( $widths.canva <= $widths.desktopNav ){
      $nav_desktop_width_remember = $widths.desktopNav;
      $nav_desktop_menu_content.css({
        'display': 'none',
        'opacity': '0'
      });
      $nav_mobile_icon.css({
        'display': 'block',
        'opacity': '1'
      });
     
    } else if( $widths.canva > $widths.desktopNav && $widths.canva > $nav_desktop_width_remember){
      $nav_desktop_menu_content.css({
        'display': 'block',
        'opacity': '1'
      });
      
      $nav_mobile_icon.css({
        'display': 'none',
        'opacity': '0'
      });

      if($('.menu-modal').hasClass('is-open')){
        menuToggleClass($menuButton, $menuModal, $menuModalBg, $menuModalContent, $backgroundBody);
      }
    } 
  };
  

  // init
  $nav_desktop_width_remember = get_nav_width();
  $nav_desktop_width_remember = $nav_desktop_width_remember.desktopNav;
  set_nav_state();

  // resize
  $(window).resize(function(){
    set_nav_state();
  });


 
});
